import { useMutation, useQuery } from "react-query"
import { useMainContext } from "../../contexts/main"
import { deleteApi } from "../fetch-api/delete"
import { filterFetch } from "../fetch-api/get"
import {useQueryContext} from "../../contexts/query";
import {makeQueryFilters} from "../../utils/query-maker";

/**
 * @typedef {Object} OrdersData
 * @property {number|null} page
 * @property {string|null} dateFrom
 * @property {Array<string>} search
 * @property {Array<string>} query
 */

/**
 * List user current orders Get api
 * @param filters
 * @param pagination
 * @returns {UseQuery}
 */
const useMyOrdersQuery = (filters, pagination) => {

    const { main: { lang }, profile: { token } } = useMainContext()
    const params = {...makeQueryFilters(filters, lang), ...pagination}

    return useQuery(
        'fetch-my-orders', () => filterFetch(params, token, "orders/my"),
        {
            enabled: !!token,
            select: (res) => (res.data),
            refetchOnWindowFocus: false
        }
    )
}


/**
 * List User Orders history Get api
 * @param filters
 * @param pagination
 * @returns {UseQuery}
 */
const useOrdersHistoryQuery = (filters, pagination) => {

    const { main: { lang }, profile: { token } } = useMainContext()
    const params = {...makeQueryFilters(filters, lang), ...pagination}

    return useQuery(
        'fetch-orders-history', () => filterFetch(params, token, "trades"),
        {
            enabled: !!token,
            select: (res) => (res.data),
            refetchOnWindowFocus: false
        }
    )
}

/**
 * Delete current order - Delete api
 * get id in mutate function
 * @returns {UseMutation}
 */
const useDeleteMyOrderMutation = () => {
    const { profile: { token } } = useMainContext()
    const {queryClient, setToast} = useQueryContext()

    return useMutation((id) => deleteApi(token, `orders/${id}`),
        {
            onSuccess: () => {
                queryClient.invalidateQueries('fetch-my-orders')
                setToast({
                    message: 'trade-success-desc', show: true
                })
            }
        }
    )
}


export {
    useMyOrdersQuery,
    useDeleteMyOrderMutation,
    useOrdersHistoryQuery
}
